import styles from './Header.module.css';
import { CgMenuRightAlt } from "react-icons/cg";

function Header(){
    return (
        <header className="bg-white container-fluid">
            <div className="container-fluid row" style={{ height: '100%' }}>
                <div className="col align-items-center d-flex">
                    <a href="/"><img className={styles.logo} src="/img/logos/logo.webp" alt="Focus"/></a>
                </div>
                <div className="col align-items-center d-xl-flex d-none justify-content-end" style={{ height: '100%' }}>
                    <nav>
                        <ul className="nav d-flex align-items-center" style={{ height: '100%' }}>
                            <li className="nav-item"><a className="nav-link text-dark fw-bold" href="#home">HOME</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#sobre">Sobre</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#beneficios">Benefícios</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#como-usar">Como Usar?</a></li>
                            <li className="nav-item btn btn-primary rounded-pill d-flex align-items-center" style={{ height: '35px' }}><a className="nav-link text-white" href="#download">Download</a></li>
                        </ul>
                    </nav>
                </div>
                <div className="col d-flex align-items-center justify-content-end d-xl-none" style={{ height: '100%' }}>
                    <CgMenuRightAlt className={styles.icon} data-bs-toggle="offcanvas" data-bs-target="#lateral-menu"/>
                </div>
            </div>

            <div id="lateral-menu" className="offcanvas offcanvas-start" style={{ width: '250px'}}>
                <div className="offcanvas-header bg-white">
                    <img src="/img/logos/logo2.webp" alt="Focus" width="70" className="mx-auto"/>
                </div>
                <div className="offcanvas-body" style={{ paddingTop: '5px'}}>
   		            <nav>
                        <ul className="nav d-block" style={{ height: '100%' }}>
                            <li className="nav-item"><a className="nav-link text-dark fw-bold" href="#home">HOME</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#sobre">Sobre</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#beneficios">Benefícios</a></li>
                            <li className="nav-item"><a className="nav-link text-dark" href="#como-usar">Como Usar?</a></li>
                            <li className="nav-item btn btn-primary rounded-pill d-flex align-items-center justify-content-center" style={{ height: '35px' }}><a className="nav-link text-white" href="#download">Download</a></li>
                        </ul>
                    </nav>
	            </div>
            </div>
        </header>  
    )
}

export default Header;